import { apiVortex } from "./api"

function submittedInitial({
  formId,
  provider,
  responseId,
  context,
  heyflow,
  userId,
  partial,
}) {
  const body = {
    formId,
    provider,
    responseId,
    context,
    heyflow,
    userId,
    partial,
  }

  return apiVortex().postConsultationsInitialSubmitted(body)
}

export { submittedInitial }
